import { render } from "./CodePreview.vue?vue&type=template&id=3b79b4a2&ts=true"
import script from "./CodePreview.vue?vue&type=script&lang=ts"
export * from "./CodePreview.vue?vue&type=script&lang=ts"

import "./CodePreview.vue?vue&type=style&index=0&id=3b79b4a2&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__